import { t } from "../../services/formatters";
import { useLuogoPage } from "./useLuogoPage";
import { TextInput } from "../../components/TextInput";
import { Button } from "../../components/Button";
import { ErrorModal } from "../../components/ErrorModal";
import { Suggestions } from "../../components/Suggestions";
import { StartOverlay } from "../../components/StartOverlay";
import { useComponentMetric } from "../../lib/otel";
import "./LuogoPage.css";

export const LuogoPage = () => {
    const {
        next,
        onLuogoChange,
        onLuogoBlur,
        onSuggestionClick,
        suggestions,
        read,
        update,
        onGeoClick,
        isFetchFilialiStart,
        isFetchFilialiWaiting,
        isFetchPositioEnd,
        getSearchInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        isLoading,
    } = useLuogoPage();

    useComponentMetric("luogo", { fetchError, fetchErrorMessage, fallbackErrorMessage: "errore recupero luogo" });

    const productBoxes = [
        {
            prodotto: "prestito",
            btnTitle: "Prestito Personale",
            title: "Vuoi un <b>Prestito Personale</b>",
        },
        {
            prodotto: "cqs",
            btnTitle: "Cessione del Quinto",
            title: "Vuoi una <b>Cessione del Quinto</b>",
        },
        {
            prodotto: "minicredito",
            btnTitle: "Minicredito ON",
            title: "Vuoi un <b>Minicredito ON</b>",
        },
        
        // {
        //     prodotto: "mutuo",
        //     btnTitle: "Mutui e Finanziamenti",
        //     title: "Vuoi un <b>Mutuo</b>",
        // },
    ];

    const getCurrentProductProperty = (property = "title") => {
        let prodToUse = productBoxes[0];
        const currentProduct = read("prodotto") || "prestito";
        const productObject = productBoxes.filter((prod) => prod.prodotto == currentProduct);
        if (productObject.length) {
            prodToUse = productObject[0];
        }
        return prodToUse[property];
    };

    return (
        <>
            {isLoading && <StartOverlay />}

            {!isLoading && (
                <div id="luogo-page">
                    <div className={`section page-title-component text-center`}>
                        <h1>
                            <span className="color-text-primary" dangerouslySetInnerHTML={{ __html: getCurrentProductProperty("title") }}></span>
                            <br />
                            Fissa qui il tuo appuntamento in una Filiale MPS
                        </h1>
                    </div>

                    <div className={`section white-box input-box-component`}>
                        <h2>{t("dove_appuntamento")}</h2>
                        <p className={`input-box-subtitle`}>&nbsp;</p>
                        <TextInput
                            isGeo={true}
                            withEllipsis={false}
                            name="cap"
                            placeholder={t("inserisci_cap")}
                            value={read("luogo")}
                            onChange={onLuogoChange}
                            onBlur={onLuogoBlur}
                            onIconClick={onGeoClick}
                            state={getSearchInputState()}></TextInput>
                        <Suggestions suggestions={suggestions} onSuggestionClick={onSuggestionClick} />

                        {isFetchPositioEnd() ? <small style={{ color: "#289680" }}>Ottimo! Abbiamo trovato una filiale vicino a te!</small> : ""}
                    </div>

                    <div className="section text-center">
                        <Button
                            id="go-to-select-state-btn"
                            disabled={!isFetchFilialiStart()}
                            onClick={next}
                            classList="btn-responsive always-style"
                            loading={isFetchFilialiWaiting()}
                            text={t("avanti")}
                        />
                    </div>

                    <div className="divider--2"></div>

                    <div
                        className="product-boxes--divider text-center"
                        style={{
                            fontWeight: 300,
                        }}>
                        Oppure sei interessato a
                    </div>

                    <div className="product-boxes--divider divider--2"></div>

                    <div className="product-boxes">
                        {productBoxes
                            .filter((p) => p.prodotto != read("prodotto"))
                            .map((product) => {
                                return (
                                    <Button
                                        text={product.btnTitle}
                                        classList="btn-responsive always-style product-box"
                                        onClick={() => {
                                            update("prodotto", product.prodotto);
                                        }}
                                    />
                                );
                            })}
                    </div>

                    <ErrorModal
                        open={fetchError}
                        text={fetchErrorMessage}
                        onCloseModal={() => {
                            setFetchError(false);
                        }}></ErrorModal>
                </div>
            )}
        </>
    );
};
